import { axiosPrivate } from '../../../api/axios';

/**
 * Fetches step logs from the server.
 * @returns {Promise<object[]>} - A promise that resolves to an array of step logs.
 */
export const fetchStepsLog = async () => {
  try {
    // Make the API request to fetch the step logs from '/steps'
    const response = await axiosPrivate.get('/steps');  // This matches the route in server.js

    if (response.status === 200) {
      // Return the data (logs) if the request was successful
      return response.data;
    } else {
      throw new Error('Failed to fetch step logs');
    }
  } catch (error) {
    // Log and rethrow any error that occurs
    console.error('Error fetching step logs:', error);
    throw error;
  }
};
